export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_ME = 'UPDATE_ME';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_IMAGE_QUEUE_PATIENT_STATUS = 'UPDATE_IMAGE_QUEUE_PATIENT_STATUS';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const UPDATE_SYSTEM_SETTINGS = 'UPDATE_SYSTEM_SETTINGS';
export const SHOW_OVERLAY = 'SHOW_OVERLAY';
export const VERIFY_DISABLED = 'VERIFY_DISABLED';
export const AUTHORIZE_PAGE = 'AUTHORIZE_PAGE';